export default __webpack_public_path__ + "static/media/illustration-health-2-m@3x.f8279225.webp";